import { createContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export type Language = {
  i18n: string;
  label: string;
};

interface LanguageContextType {
  language: Language;
  languageOptions: Language[];
  setLanguage: (language: Language) => void;
}

export const LanguageContext = createContext<LanguageContextType>(
  {} as LanguageContextType,
);

const LANGUAGE_OPTIONS: Language[] = [
  { i18n: "en", label: "English" },
  { i18n: "gr", label: "Greek" },
  { i18n: "fr", label: "French" },
  { i18n: "de", label: "German" },
  { i18n: "nl", label: "Dutch" },
  { i18n: "es", label: "Spanish" },
  { i18n: "it", label: "Italian" },
];

export function useLanguageContext(): LanguageContextType {
  const { i18n } = useTranslation();

  const savedIndex = LANGUAGE_OPTIONS.findIndex(
    (x) => x.i18n === localStorage.getItem("language"),
  );
  const startIndex = savedIndex === -1 ? 0 : savedIndex;
  if (savedIndex === -1) {
    localStorage.setItem("language", "en");
  }

  const [language, setLanguage] = useState<Language>(
    LANGUAGE_OPTIONS[startIndex],
  );

  useEffect(() => {
    i18n.changeLanguage(language.i18n);
    localStorage.setItem("language", language.i18n);
  }, [language, i18n]);

  return { language, languageOptions: LANGUAGE_OPTIONS, setLanguage };
}
